module.exports = __webpack_public_path__ + "img/rtb_silo_0.c4ab3d93.png";